export default __webpack_public_path__ + "static/connections-mob-f15da9585ff20c279cb8cdc92e4392bb.jpg";